import { Typography, Container } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { useIsMobile } from '@client/hooks/dom.hooks';
import { SignupButton } from './common/SignupButton';

const useStyles = makeStyles()((theme) => ({
  root: {
    [theme.breakpoints.down('md')]: {
      paddingTop: theme.spacing(3),
    },
  },
  heading: {
    marginBottom: theme.spacing(2),
    maxWidth: 700,
  },
  subheading: {
    marginBottom: theme.spacing(3),
    maxWidth: 700,
  },
}));

export const CTA = () => {
  const { classes } = useStyles();
  const isMobile = useIsMobile();

  return (
    <Container
      maxWidth="md"
      className={classes.root}
    >
      <Typography
        variant={isMobile ? 'h4' : 'h2'}
        className={classes.heading}
      >
        Empowering The Independent Live Music Community
      </Typography>

      <Typography
        variant={isMobile ? 'subtitle1' : 'h5'}
        className={classes.subheading}
      >
        Keep 100% of your ticket revenue.
        {isMobile ? <br /> : ' '}
        Connect with venues and artists who share your values.
      </Typography>

      <SignupButton
        id="sda-home-cta-signup-button"
      />
    </Container>
  );
};
